

import __layout_0 from '/D:/CM-EPS-SCGJ/snw-info/smil-snw-info-frontend/src/layouts/default.vue'
export const layouts = {
'auth': () => import('/D:/CM-EPS-SCGJ/snw-info/smil-snw-info-frontend/src/layouts/auth.vue'),
'default': __layout_0,
'home': () => import('/D:/CM-EPS-SCGJ/snw-info/smil-snw-info-frontend/src/layouts/home.vue'),
'topMenu': () => import('/D:/CM-EPS-SCGJ/snw-info/smil-snw-info-frontend/src/layouts/topMenu.vue'),
'default-modules/routeSearch': () => import('/D:/CM-EPS-SCGJ/snw-info/smil-snw-info-frontend/src/layouts/default-modules/routeSearch.vue'),
'english-export-Dialog/english-export-dialog': () => import('/D:/CM-EPS-SCGJ/snw-info/smil-snw-info-frontend/src/layouts/english-export-Dialog/english-export-dialog.vue'),
}

export function setupLayouts(routes) {
  return routes.map(route => {
    return { 
      path: route.path,
      meta: route.meta,
      component: layouts[route.meta?.layout || 'default'],
      children: route.path === '/' ? [route] : [{...route, path: ''}]
    }
  })
}
